/**
 * Angular imports.
 */
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Module imports.
 */
import { ProductMaskingCardModule } from './../../../../common/product-masking-card/product-masking-card.module';
import { DirectivesModule } from './../../../../directives/directives.module';
import { NgbDropDownModule } from './../../../../common/ngb-drop-down/ngb-drop-down.module';
import { PipesModule } from './../../../../pipes/pipes.module';
import { DynamicFormModule } from './../../../../dynamic-form/dynamic-form.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { WalkthroughModule } from '../../../../walkthrough/walkthrough.module';

/**
 * Component imports.
 */
import { WebinarCardComponent } from './webinar-card.component';
import { AnalyticsEventModule } from './../../../../analytics-event/analytics-event.module';



@NgModule({
  declarations: [
    WebinarCardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    NgbDropDownModule,
    DirectivesModule,
    ProductMaskingCardModule,
    AnalyticsEventModule,
    DynamicFormModule,
    ModalModule,
    WalkthroughModule
  ],
  exports: [
    WebinarCardComponent
  ]
})
export class WebinarCardModule { }
